import createModule from "../createModule"
import { getFacetTypes, getRawClassifications, getClassifications } from "./selectors"
import { Creators } from "./model"
import { generateClassificationFacetQuery } from "helpers/classification"
import { mapFactorExposureNegativeBoolOperator } from "helpers/filters"
import view from "./view"

export default createModule({
  view,
  externalProps: (state, props) => ({
    account: state.global.selected.account,
    modelId: props.modelId,
    currency: props.currency,
    id: state.modules.securitiesFinderResults.id,
    filter: props.filter,
    filterId: props.filterId,
    classifications: getRawClassifications(state, props),
  }),
  required: ["account", "modelId", "classifications"],
  data: [{
    resource: "searchFacets",
    url: ({ modelId, filterId, filter, selectedDate, classifications, currency }) => {
      if (!filterId) {
        return null
      }

      filter = mapFactorExposureNegativeBoolOperator(filter)

      return {
        id: `${modelId}${filterId}${selectedDate}${currency}`,
        options: {
          ignoreMessages: true, // messages already handled by full query
        },
        query: `query ($modelId: String!, $filter: [SecuritySearchFilter!]!, $on: Date!, $currency: Currency) {
          model (id: $modelId) {
            securitySearch (filter: $filter, on: $on, currency: $currency) {
              count
              countries {
                id
                count
              }
              ${generateClassificationFacetQuery(classifications)}
              currencies {
                id
                count
              }
            }
          }
        }`,
        variables: {
          modelId,
          filter,
          on: selectedDate,
          currency,
        },
      }
    },
  }],
  actions: Creators,
  mapStateToProps: (state, props) => ({
    facetTypes: getFacetTypes(state, props),
    expanded: state.modules.securitiesFinderFacets.expanded,
    classifications: getClassifications(state, props),
  }),
})
